"use client";

import { useMutation } from "@tanstack/react-query";
import type { Cart, CartUpdateType } from "@/features/cart/types";
import { ApiError } from "@/lib/helpers/errors";

type RecreateCartResponse = {
  cart: Cart;
  cartId: string;
};

export const useRecreateCart = () =>
  useMutation({
    mutationFn: async (body: CartUpdateType) => {
      const response = await fetch("/api/cart/recreate", {
        body: JSON.stringify(body),
        method: "POST",
      });

      if (!response.ok) {
        const error = (await response.json().catch(() => null)) as {
          error?: string;
        } | null;

        throw new ApiError(
          error?.error ?? "cart_recreation_failed",
          response.status,
          error,
        );
      }

      return (await response.json()) as RecreateCartResponse;
    },
  });
